module.exports = __webpack_public_path__ + "img/fallback_fav.054237a2.png";